<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Home' }">Accueil</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Liste des contrats
        </li>
      </ol>
    </nav>
    <b-row>
      <b-col>
        <b-form-group
          label="Filtrer"
          label-cols-sm="3"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="Taper pour rechercher un statut (actif, inactif, expire), un id, ou un établissement"
            />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''"
                >Effacer
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      :fields="fields"
      :items="contracts"
      :filter="filter"
      :filter-function="filterTable"
      :filter-included-fields="filterOn"
      small
    >
      <template #cell(status)="row" class="align-middle">
        <b-badge :variant="getBadgeActif(row.item).badge">
          {{ row.item.label }}</b-badge
        >
      </template>
      <template #cell(cont_id)="data" class="align-middle">
        {{ data.value }}
      </template>
      <template #cell(establishments)="data">
        <div v-if="data.value.length === 0"><i>Pas d'établissement lié</i></div>
        <div
          v-for="establishment in data.value"
          v-else
          :key="'esta' + establishment.esta_id"
        >
          {{ establishment.esta_name }}
        </div>
        <!--TODO : Ajouter un petit bouton pour visualiser l'etablissement -->
      </template>
      <template #cell(details)="row">
        <b-button
          :to="{ name: 'ContractDetails', params: { id: row.item.cont_id } }"
          variant="outline-primary"
          >Détails
        </b-button>
      </template>
      <template #cell(cont_date_end)="data">
        <div>
          <p
            :class="{
              danger: data.value <= 0,
              warning: data.value > 0 && data.value < 6,
            }"
          >
            {{ displayDate(data.value) }}
          </p>
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
import { mapState } from "vuex";

const moment = require("moment");

moment().format();

export default {
  data() {
    return {
      fields: [
        {
          status: {
            label: "Statut",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          cont_id: {
            label: "Numéro de contrat",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          establishments: {
            label: "Établissements",
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          details: {
            label: "Détails",
            sortable: false,
            tdClass: "align-middle",
          },
        },
        {
          cont_date_end: {
            label: "Expiration (Mois)",
            sortable: true,
            sortByFormatted: true,
            formatter: (value) => this.displayNumberMonthExpiration(value),
            tdClass: "align-middle",
          },
        }
      ],
      dateNow: moment(),
      filter: null,
      filterOn: [],
    };
  },
  computed: mapState({
    contracts: (state) => state.contracts.all,
  }),
  created() {
    this.$store.dispatch("contracts/getAllContracts");
  },
  methods: {
    compareDate(checkDate, endDate) {
      return endDate == null && moment(checkDate).isBefore(moment());
    },
    displayNumberMonthExpiration(dateContract) {
      if (dateContract) {
        const dateEnd = moment(dateContract, "DD/MM/YYYY");
        const dateStart = moment();
        return parseInt(dateEnd.diff(dateStart, "months", true), 10);
      }
      return "99";
    },
    displayDate(numberMonth) {
      return moment().add(numberMonth, "M").format("MM/YYYY");
    },
    isActif(dateEnd) {
      return this.displayNumberMonthExpiration(dateEnd) > 0;
    },
    filterTable(row, filter) {
      if (filter.trim().toLowerCase() === 'actif') {
        return (
          this.isActif(row.cont_date_end) &&
          this.displayNumberMonthExpiration(row.cont_date_end) >= 6
        );
      }
      if (filter.trim().toLowerCase() === "inactif") {
        return !this.isActif(row.cont_date_end);
      }
      if (filter.trim().toLowerCase() === "expire") {
        return (
          this.isActif(row.cont_date_end) &&
          this.displayNumberMonthExpiration(row.cont_date_end) < 6 &&
          this.displayNumberMonthExpiration(row.cont_date_end) > 0
        );
      }
      if (Math.ceil(filter)) {
        return row.cont_id === parseInt(filter, 10) ||
          (row.establishments !== null && row.establishments.length > 0)
          ? row.establishments.some((i) => i.esta_id === parseInt(filter, 10))
          : false;
      }
      return row.establishments !== null && row.establishments.length > 0
        ? row.establishments.some((i) => i.esta_name.toLowerCase().includes(filter.trim().toLowerCase()))
        : false;
    },
    getBadgeActif(item) {
      const expire = this.displayNumberMonthExpiration(item.cont_date_end);
      const actif = expire > 0;
      if (item.cont_date_end != null && !actif) {
        item.badge = "danger";
        item.label = "Inactif";
      } else if (
        item.cont_date_end != null &&
        actif &&
        expire < 6 &&
        expire > 0
      ) {
        item.badge = "warning";
        item.label = "Expire bientôt";
      } else if (actif && expire > 6) {
        item.badge = "success";
        item.label = "Actif";
      } else {
        item.badge = "";
        item.label = "";
      }
      return item;
    },
  },
};
</script>
<style>
.warning {
  background: yellow;
  font-weight: bold;
  color: black;
}
.danger {
  background: darkred;
  font-weight: bold;
  color: white;
}
</style>
